import { Input, Output, EventEmitter, OnChanges } from '@angular/core';

export abstract class BaseButton {

    private static buttonStyles = [
        'danger',
        'dark',
        'info',
        'light',
        'link',
        'primary',
        'secondary',
        'success',
        'warning',
        'outline-danger',
        'outline-dark',
        'outline-info',
        'outline-light',
        'outline-link',
        'outline-primary',
        'outline-secondary',
        'outline-success',
        'outline-warning'
    ];

    @Input() text: string;

    @Input() icon: string;

    @Input() btnStyle: string;

    @Input() btnClass: string;

    @Input() disabled = false;

    @Input() size: string;

    @Input() working: boolean;

    /**
     * Click event (deprecated)
     *
     * @type {EventEmitter<any>}
     * @memberof BaseButton
     * @deprecated click is also the DOM click-event, this conflict causes issues in IE. Use 'buttonClick' instead
     */
    @Output() click: EventEmitter<any> = new EventEmitter();

    /**
     * Click event
     *
     * @type {EventEmitter<any>}
     * @memberof BaseButton
     */
    @Output() buttonClick: EventEmitter<any> = new EventEmitter();

    buttonClass: string;

    private initialized: boolean;

    onInit() {
        if (!this.btnStyle) {
            this.btnStyle = 'primary';
        }

        if (!this.size) {
            this.size = 'default';
        }

        if (this.text === undefined) {
            throw new Error('Always provide a descriptive text... It will be shown as title (on mouse hover) and is required for ARIA');
        }

        this.initialized = true;
        this.onChanges();
    }

    onChanges() {
        if (!this.initialized) {
            return;
        }

        const cls = ['btn'];

        const styleIndex = BaseButton.buttonStyles.indexOf(this.btnStyle);
        if (styleIndex >= 0) {
            cls.push('btn-' + BaseButton.buttonStyles[styleIndex]);
        } else {
            throw new Error('invalid button style "' + this.btnStyle + '". Valid values are: ' + BaseButton.buttonStyles.join(', '));
        }

        switch (this.size) {
            case 'large':
                cls.push('btn-lg');
                break;
            case 'small':
                cls.push('btn-sm');
                break;
            case 'default':
                break;
            default:
                throw new Error('invalid button size value: ' + this.size);
        }

        if (this.btnClass) {
            this.btnClass.split(' ').forEach(c => {
                cls.push(c);
            });
        }

        if (this.disabled || this.working) {
            cls.push('disabled');
        }

        this.buttonClass = cls.join(' ');
    }

    /**
     * Handle click event
     *
     * @public
     * @param {MouseEvent} event
     * @memberof BaseButton
     */
    public onClick(event: MouseEvent) {
        if (!this.disabled) {
            this.click.emit(event);
            this.buttonClick.emit(event);
        }
        event.stopPropagation();
    }

    get iconClass(): string {
        return 'oi oi-' + this.icon;
    }
}
